(() => {
  if (customElements.get('f01-rail')) return;
  class F01Rail extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.track = this.querySelector('.f01-rail-track, .f01-gallery-track');
      this.controls = this.querySelector('.f01-rail-controls, .f01-gallery-controls');
      if (!this.track) return;
      this.dots = this.querySelector('.f01-dots');
      this.prev = this.querySelector('[data-f01-prev]');
      this.next = this.querySelector('[data-f01-next]');
      this.positions = [];
      const signal = this.abort.signal;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { passive: true, signal });
      this.prev?.addEventListener('click', () => this.go(this.index - 1), { signal });
      this.next?.addEventListener('click', () => this.go(this.index + 1), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const child = Array.from(this.track.children).find(e => e.contains(event.target));
        if (child) this.track.scrollTo({left: child.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'auto'});
      }, { signal });
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.track);
      this.measure();
    }
    measure() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const start = this.track.firstElementChild?.offsetLeft || 0;
      this.positions = Array.from(this.track.children).map(e => Math.min(maximum, Math.max(0, e.offsetLeft - start)));
      this.positions = this.positions.filter((n, i, a) => i === 0 || Math.abs(n - a[i - 1]) > 2);
      if (this.controls) this.controls.hidden = maximum < 3;
      if (this.dots) {
        this.dots.replaceChildren(...this.positions.map((_, i) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'f01-dot';
          button.setAttribute('aria-label', `${i + 1} / ${this.positions.length}`);
          button.addEventListener('click', () => this.go(i));
          return button;
        }));
      }
      this.update();
    }
    update() {
      this.index = this.positions.reduce((best, p, i, a) => Math.abs(p - this.track.scrollLeft) < Math.abs(a[best] - this.track.scrollLeft) ? i : best, 0);
      this.dots?.querySelectorAll('button').forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.positions.length - 1;
      this.querySelectorAll('[data-f01-panel]').forEach((panel, i) => panel.hidden = i !== this.index);
    }
    go(index) {
      const destination = this.positions[Math.max(0, Math.min(index, this.positions.length - 1))] || 0;
      this.track.scrollTo({left: destination, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
      this.abort = null;
    }
  }
  customElements.define('f01-rail', F01Rail);
  customElements.define('f01-gallery', class extends F01Rail {});
})();
